var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _class, _temp;

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React, { Component } from 'react';
import t from 'prop-types';
import ConenidoVentana from '../contenido-ventana';
import { MarcoAmpliacion, Precarga } from '../../index';
var ContenidoTipoZoom = (_temp = _class = function (_Component) {
  _inherits(ContenidoTipoZoom, _Component); // TODO: Escalar todos los hijos al tamaño de la imagen que pintamos
  // para que tanto pizarra como textosUsuario permanezcan en posiciones
  // relativas coherentes respecto a la imagen que se pinta


  function ContenidoTipoZoom(props) {
    _classCallCheck(this, ContenidoTipoZoom);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.recalcularRectImagenFinal = function () {
      var imagenRecortadaNaturalSize = _this.state.imagenRecortadaNaturalSize;

      if (_this.state.imagenFinalRect.width !== imagenRecortadaNaturalSize.width || _this.state.imagenFinalRect.height !== imagenRecortadaNaturalSize.height) {
        var onImagenFinalRect = _this.props.onImagenFinalRect;
        onImagenFinalRect && onImagenFinalRect(imagenRecortadaNaturalSize);

        _this.setState({
          imagenFinalRect: imagenRecortadaNaturalSize
        });
      }
    };

    _this.handleImagenReferenciaLoaded = function () {
      var imagenFinalDataUrl = _this.crearImagenFinalDataUrl();

      _this.setState({
        loading: false,
        imagenFinalDataUrl: imagenFinalDataUrl
      }, _this.recalcularRectImagenFinal);
    };

    _this.handleImagenRecortadaLoaded = function () {
      var _this$imagenRecortada = _this.imagenRecortadaRef.current,
          naturalWidth = _this$imagenRecortada.naturalWidth,
          naturalHeight = _this$imagenRecortada.naturalHeight,
          width = _this$imagenRecortada.width,
          height = _this$imagenRecortada.height;

      _this.setState({
        imagenRecortadaNaturalSize: {
          width: naturalWidth,
          height: naturalHeight,
          w: width,
          h: height
        }
      });
    };

    _this.calcularRecorte = function (coordenadas) {
      var acumuladorInicial = {
        xMin: 99999,
        yMin: 99999,
        xMax: 0,
        yMax: 0
      };
      var limites = coordenadas.reduce(function (acumulador, _ref) {
        var x = _ref[0],
            y = _ref[1];
        var xMin = acumulador.xMin,
            yMin = acumulador.yMin,
            xMax = acumulador.xMax,
            yMax = acumulador.yMax;

        if (x < xMin) {
          acumulador.xMin = x;
        }

        if (x > xMax) {
          acumulador.xMax = x;
        }

        if (y < yMin) {
          acumulador.yMin = y;
        }

        if (y > yMax) {
          acumulador.yMax = y;
        }

        return acumulador;
      }, acumuladorInicial);
      var xMin = limites.xMin,
          yMin = limites.yMin,
          xMax = limites.xMax,
          yMax = limites.yMax;
      var recorte = {
        sx: xMin,
        sy: yMin,
        sw: xMax - xMin,
        sh: yMax - yMin
      };
      return recorte;
    };

    _this.state = {
      loading: true,
      // resized: props.resized,
      hasVerticalScrollbar: false,
      imagenFinalDataUrl: null,
      imagenFinalRect: {
        width: "100%",
        height: "100%"
      },
      imagenRecortadaNaturalSize: {
        width: 0,
        height: 0
      }
    };
    _this.imagenOrigenRef = React.createRef();
    _this.imagenRecortadaRef = React.createRef();
    _this.marcoAmpliacionRef = React.createRef();
    return _this;
  }

  ContenidoTipoZoom.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    var _this2 = this;

    if (prevProps.imagen !== this.props.imagen) {
      this.setState({
        loading: true
      });
      return;
    }

    if (JSON.stringify(prevProps.coordenadas) !== JSON.stringify(this.props.coordenadas)) {
      this.handleImagenReferenciaLoaded();
      setTimeout(function () {
        return _this2.forceUpdate();
      }, 0);
    }

    if (JSON.stringify(prevProps.escala) !== JSON.stringify(this.props.escala)) {
      setTimeout(function () {
        return _this2.forceUpdate();
      }, 0);
    } //if (prevProps.anchoDisponible !== this.props.anchoDisponible || prevProps.altoDisponible !== this.props.altoDisponible) {


    if (JSON.stringify(prevState.imagenRecortadaNaturalSize) !== JSON.stringify(this.state.imagenRecortadaNaturalSize)) {
      this.recalcularRectImagenFinal();
    }

    var forzarTopCero = this.hayScroll();

    if (forzarTopCero !== this.state.forzarTopCero) {
      this.setState({
        forzarTopCero: forzarTopCero
      });
    }
  };

  ContenidoTipoZoom.prototype.hayScroll = function hayScroll() {
    var marcoAmpliacion = this.marcoAmpliacionRef.current;

    if (!marcoAmpliacion) {
      return false;
    }

    var resultado = marcoAmpliacion.elem.clientHeight < marcoAmpliacion.elem.scrollHeight;
    return resultado;
  };

  ContenidoTipoZoom.prototype.crearImagenFinalDataUrl = function crearImagenFinalDataUrl() {
    var image = this.imagenOrigenRef.current;
    var coordenadas = this.props.coordenadas;

    var _calcularRecorte = this.calcularRecorte(coordenadas),
        sx = _calcularRecorte.sx,
        sy = _calcularRecorte.sy,
        sw = _calcularRecorte.sw,
        sh = _calcularRecorte.sh;

    var canvas = document.createElement("canvas");
    canvas.width = sw;
    canvas.height = sh;
    var ctx = canvas.getContext('2d');
    ctx.imageSmoothingEnabled = false;
    ctx.drawImage(image, sx, sy, sw, sh, 0, 0, sw, sh); // mascara

    ctx.globalCompositeOperation = 'destination-in';
    ctx.translate(-sx, -sy);
    ctx.beginPath();
    ctx.moveTo(coordenadas[0][0], coordenadas[0][1]);

    for (var i = 1; i < coordenadas.length; i++) {
      ctx.lineTo(coordenadas[i][0], coordenadas[i][1]);
    }

    ctx.closePath();
    ctx.fillStyle = '#fff';
    ctx.fill();
    return canvas.toDataURL();
  };

  ContenidoTipoZoom.prototype.calcularImagenFinalStyle = function calcularImagenFinalStyle() {
    var _props = this.props,
        factor = _props.factor,
        escala = _props.escala,
        ajuste = _props.ajuste,
        lupa = _props.lupa,
        contenido = _props.contenido,
        configLibros = _props.configLibros,
        esPrimeraVentana = _props.esPrimeraVentana;
    var forzarTopCero = this.state.forzarTopCero;
    var coordenadas = this.props.coordenadas;

    var _calcularRecorte2 = this.calcularRecorte(coordenadas),
        sw = _calcularRecorte2.sw;

    var anchoPNG = configLibros ? configLibros[contenido.libroId].dimensionesAlta.w : sw;
    var multiplicadorEscala = esPrimeraVentana ? sw / anchoPNG : 1;
    var escalaLupaSi = multiplicadorEscala * escala;

    if (lupa === 'si') {
      var factorReal = factor * escalaLupaSi / 100;
      var transformX = factorReal > 100 ? -50 + (factorReal - 100) / (2 * factorReal / 100) : -50;
      return ajuste === "ancho" || forzarTopCero ? {
        position: "absolute",
        width: factor * escalaLupaSi / 100 + '%',
        top: 0,
        left: "50%",
        transform: 'translate(' + transformX + '%, 0)'
      } :
      /*            (ajuste === "alto") 
                  ? {
                      position: "absolute",
                      maxWidth: `${factor*escala/100}%`, 
                      maxHeight: `${factor*escala/100}%`,
                      height: `${factor*escala/100}%`,
                      top: "50%",
                      left: "50%",
                      transform: `translate(-50%, ${transformX}%)`
                  }
                  :*/
      {
        position: "absolute",
        width: factor * escalaLupaSi / 100 + '%',
        top: "50%",
        left: "50%",
        transform: 'translate(' + transformX + '%, -50%)'
      };
    }

    var imagenRecortadaNaturalSize = this.state.imagenRecortadaNaturalSize;
    return ajuste === "ancho" ? {
      position: "absolute",
      width: escala + '%',
      top: 0,
      left: "50%",
      transform: "translate(-50%, 0)",
      maxWidth: imagenRecortadaNaturalSize ? imagenRecortadaNaturalSize.width : '100%'
    } : {
      position: "absolute",
      maxWidth: escala + '%',
      maxHeight: escala + '%',
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)"
    };
  };

  ContenidoTipoZoom.prototype.render = function render() {
    var _props2 = this.props,
        imagen = _props2.imagen,
        children = _props2.children;
    var _state = this.state,
        loading = _state.loading,
        imagenFinalDataUrl = _state.imagenFinalDataUrl;
    var imagenFinalStyle = this.calcularImagenFinalStyle();
    return React.createElement(ConenidoVentana, null, React.createElement(MarcoAmpliacion, {
      id: 'contenido-tipo-zoom',
      factor: 100,
      deshabilitado: true,
      onDragged: function onDragged() {},
      ref: this.marcoAmpliacionRef
    }, React.createElement('img', {
      ref: this.imagenOrigenRef,
      onLoad: this.handleImagenReferenciaLoaded,
      src: imagen,
      style: {
        display: 'none'
      },
      alt: ''
    }), loading && React.createElement(Precarga, null), imagenFinalDataUrl && React.createElement('img', {
      ref: this.imagenRecortadaRef,
      src: imagenFinalDataUrl,
      style: _extends({}, imagenFinalStyle),
      onLoad: this.handleImagenRecortadaLoaded,
      alt: ''
    }), imagenFinalDataUrl && this.imagenRecortadaRef.current && React.createElement('div', {
      className: 'contenido-tipo-zoom-children',
      style: _extends({}, imagenFinalStyle, {
        width: this.imagenRecortadaRef.current.width,
        height: this.imagenRecortadaRef.current.height
      })
    }, children)));
  };

  return ContenidoTipoZoom;
}(Component), _class.defaultProps = {
  ajuste: "auto",
  escala: 100,
  factor: 100
}, _temp);
ContenidoTipoZoom.propTypes = process.env.NODE_ENV !== "production" ? {
  // marcoAmpliacionId: t.string,
  factor: t.number,
  imagen: t.string,
  coordenadas: t.any,

  /** ajuste del recorte */
  ajuste: t.oneOf(['auto', 'ancho']),

  /** escala del contenedor */
  escala: t.number,
  lupa: t.string,
  contenido: t.object,
  configLibros: t.object,
  esPrimeraVentana: t.bool,

  /** nos informa de que el contenedor padre ha cambiado de tamaño */
  onResize: t.func,

  /** espacio disponible */
  anchoDisponible: t.number,
  altoDisponible: t.number,
  children: t.any,
  onImagenFinalRect: t.func
} : {};
export default ContenidoTipoZoom;